import React, { useContext, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { debounce } from 'throttle-debounce'
import context from '../core/context'

function SearchSkills({ skills, roles, experience }) {
  const { isSelected, toggleFilter } = useContext(context)
  const input = useRef(null)
  const [results, setResults] = useState({
    skills: [],
    roles: [],
    experience: [],
  })
  const renderResults =
    results.skills.length > 0 || results.roles.length > 0 || results.experience.length > 0

  const filterResults = debounce(500, function (e) {
    const { target } = e
    const { value } = target

    const filteredSkills = value
      ? skills.filter(skill => skill.name.toLowerCase().includes(value.toLowerCase()))
      : []

    const filteredRoles = value
      ? roles.filter(role => role.name.toLowerCase().includes(value.toLowerCase()))
      : []

    const filteredExperience = value
      ? experience.filter(exp => exp.name.toLowerCase().includes(value.toLowerCase()))
      : []

    setResults({
      skills: filteredSkills,
      roles: filteredRoles,
      experience: filteredExperience,
    })
  })

  function resetFilters() {
    if (input.current) input.current.value = ''
    setResults({
      skills: [],
      roles: [],
      experience: [],
    })
  }

  function handleFilterClick(e) {
    const { target } = e
    const { id, type } = target.dataset
    resetFilters()
    toggleFilter(Number(id), type)
  }

  return (
    <div className="developer-search__search">
      <div className="developer-search__search__input">
        <input type="search" onInput={filterResults} ref={input} />
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={20}
          height={20}
        >
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
        </svg>
      </div>
      {renderResults && (
        <div className="developer-search__search__results">
          {results.skills.length > 0 && (
            <div className="developer-search__search__group">
              <span className="label">Skills</span>
              {results.skills.map(skill => (
                <button
                  className={`option${isSelected(skill.term_id, 'skill') ? ' option--selected' : ''}`}
                  type="button"
                  key={skill.term_id}
                  data-id={skill.term_id}
                  data-type="skill"
                  onClick={handleFilterClick}
                >
                  {skill.name}
                </button>
              ))}
            </div>
          )}
          {results.roles.length > 0 && (
            <div className="developer-search__search__group">
              <span className="label">Roles</span>
              {results.roles.map(role => (
                <button
                  className={`option${isSelected(role.term_id, 'role') ? ' option--selected' : ''}`}
                  type="button"
                  key={role.term_id}
                  data-id={role.term_id}
                  data-type="role"
                  onClick={handleFilterClick}
                >
                  {role.name}
                </button>
              ))}
            </div>
          )}
          {results.experience.length > 0 && (
            <div className="developer-search__search__group">
              <span className="label">Career Trajectory</span>
              {results.experience.map(exp => (
                <button
                  className={`option${isSelected(exp.term_id, 'experience') ? ' option--selected' : ''}`}
                  type="button"
                  key={exp.term_id}
                  data-id={exp.term_id}
                  data-type="experience"
                  onClick={handleFilterClick}
                >
                  {exp.name}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

SearchSkills.propTypes = {
  skills: PropTypes.array.isRequired,
  roles: PropTypes.array.isRequired,
  experience: PropTypes.array.isRequired,
}

export default SearchSkills
